/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Michelin-Karte`
};

const en_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Michelin map`
};

const es_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Duplicado Michelin`
};

const fr_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Calque Michelin`
};

const it_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Aspetto Michelin`
};

const nl_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Michelinlaag`
};

const pt_layers__michelin__imagex_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Calco Michelin`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__imagex_alt = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.layers__michelin__imagex_alt(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("layers__michelin__imagex_alt", locale)
	if (locale === "de") return de_layers__michelin__imagex_alt(inputs)
	if (locale === "en") return en_layers__michelin__imagex_alt(inputs)
	if (locale === "es") return es_layers__michelin__imagex_alt(inputs)
	if (locale === "fr") return fr_layers__michelin__imagex_alt(inputs)
	if (locale === "it") return it_layers__michelin__imagex_alt(inputs)
	if (locale === "nl") return nl_layers__michelin__imagex_alt(inputs)
	return pt_layers__michelin__imagex_alt(inputs)
};